import { Helmet } from 'react-helmet';
import config from '../config';
import { useEffect, useState } from 'react';
import getMessage from '../utils/getMessage';
import LoadSpinner from './LoadSpinner';
import { FormattedMessage } from 'react-intl';

export const OIDCCallBack = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const getToken = async () => {
    const queryParams = window.location.search;
    await fetch(`${config.apiBaseUrl}/oidc/callback/${queryParams}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(responseJson => { if (responseJson.token) sessionStorage.setItem('token', responseJson.token)})
      .then(() => window.open('/', '_self'))
      .catch(() => {
        setLoading(false);
        setError(true);
      })
  };
  useEffect( () => {
    getToken();
  }, []);

  return (
    <div className="hds-form hds-form--login">
      <Helmet title={getMessage('loggingIn')}/>
      <h1><FormattedMessage id='loggingIn'/></h1>
      {loading && <LoadSpinner />}
      {error && <FormattedMessage id="loginFailed" />}
    </div>
  )
}